<template>
  <div id="orderReport" v-if="orderReport.selectAuth">
    
     <iframe id="mainIframe" name="mainIframe" width="100%" height="1000px" src="https://me.bdp.cn/share/index.html?shareId=sdo_4e0b54a32fb356a25954777b78634c11" frameborder="0" scrolling="auto" ></iframe>

    <!-- <el-row type="flex"  justify="space-between">
      <el-col :span="6">
        <div >

                   <iframe id="mainIframe" name="mainIframe" width="1000%" src="https://me.bdp.cn/api/su/P9EH0UNL" frameborder="0" scrolling="auto" ></iframe>
          <chart :options="orderReportAll"/>
        </div>
      </el-col>
      <el-col :span="6">
        <div >

        </div>
      </el-col>
      <el-col :span="6">
        <div>

        </div>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
  import {getPermission} from "../../api/authRequest";
  import ECharts from "vue-echarts";
  import "echarts/lib/component/tooltip";
  import"echarts/lib/chart/bar";
  import "echarts/lib/component/title";
  import "echarts/lib/chart/line"
  export default {
    components: {
      'chart': ECharts
    },
    data() {
      return{
        orderReport: {
          selectAuth: false
        },
        orderReportAll: {
        }
      }
    },
    created() {

    },
    mounted() {
      this.orderReport.selectAuth = getPermission("/system/finReport/getReport");
      this.getAll();
    },
    methods: {
      getAll(){
        this.orderReportAll={
          backgroundColor: "#344b58",
          title:{
            text:"订单汇总",
             textStyle: {
              color: '#fff',
              fontSize: '22'
            },
          },
          "xAxis": [{
            "type": "category",
            "axisLine": {
              lineStyle: {
                color: '#90979c'
              }
            },
            "splitLine": {
              "show": false
            },
            "axisTick": {
              "show": false
            },
            "splitArea": {
              "show": false
            },
            "axisLabel": {
              "interval": 0,

            },
            "data": [1,2,3,4,5,6,7,8,9,10,11,12],
          }],
          "yAxis": [{
            "type": "value",
            "splitLine": {
              "show": false
            },
            "axisLine": {
              lineStyle: {
                color: '#90979c'
              }
            },
            "axisTick": {
              "show": false
            },
            "axisLabel": {
              "interval": 0,

            },
            "splitArea": {
              "show": false
            },

          }],
          series: [{
            "data": [709,1917,2455,2610,1719,1433,1544,3285,5208,3372,2484,4078],
            type: 'bar',
            "itemStyle": {
              "normal": {
                "color": "rgba(255,144,128,1)",
                "label": {
                  "show": true,
                  "textStyle": {
                    "color": "#fff"
                  },
                  "position": "insideTop",
                  formatter: function(p) {
                    return p.value > 0 ? (p.value) : '';
                  }
                }
              }
            },
          }]
        }
      }
    },
  }
</script>
<style type="text/css" lang="scss" scoped>
  #orderReport{
    .el-row {
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
    .el-col {
      border-radius: 4px;
    }
    .bg-purple-dark {
      background: #99a9bf;
    }
    .bg-purple {
      background: #d3dce6;
    }
    .bg-purple-light {
      background: #e5e9f2;
    }
    .grid-content {
      border-radius: 4px;
      min-height: 36px;
    }
    .row-bg {
      padding: 10px 0;
      background-color: #f9fafc;
    }
  }
</style>



// WEBPACK FOOTER //
// orderReport.vue?02664f86